console.log('Flayvr theme v1.0.4 loaded');

(function(){
  function initRevealCards(scope){
    const root = scope || document;
    const cards = root.querySelectorAll('.product-card, .aesop-rec-card, [data-reveal-card]');
    if (!cards.length) return;

    if (!('IntersectionObserver' in window)) {
      cards.forEach(card => card.classList.add('visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const card = entry.target;
        requestAnimationFrame(() => card.classList.add('visible'));
        observer.unobserve(card);
      });
    }, { threshold: 0.16, rootMargin: '0px 0px -65px 0px' });

    cards.forEach((card, index) => {
      if (card.dataset.revealBound === 'true') return;
      card.dataset.revealBound = 'true';
      card.style.setProperty('--reveal-delay', Math.min(index % 6, 5) * 70 + 'ms');
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initRevealCards(document));
  } else {
    initRevealCards(document);
  }

  document.addEventListener('shopify:section:load', event => initRevealCards(event.target));
})();


/* Alpha 92 no-layout cart add reliability fix */
(function(){
  if (window.__flayvrCartAddFix) return;
  window.__flayvrCartAddFix = true;

  function closestAddButton(target){
    return target && target.closest && target.closest('[data-add-to-cart], [data-mobile-add], .atlas-sticky-add, .product-form__submit, button[name="add"]');
  }

  function isProductAddButton(btn){
    if (!btn) return false;
    if (btn.closest('[data-cart-line-key]')) return false;
    if (btn.closest('.cart-drawer')) return false;
    return !!(
      btn.matches('[data-add-to-cart]') ||
      btn.matches('[data-mobile-add]') ||
      btn.matches('.atlas-sticky-add') ||
      btn.matches('.product-form__submit') ||
      btn.matches('button[name="add"]')
    );
  }

  function variantIdFromButton(btn){
    if (!btn) return null;

    const addValue = btn.getAttribute('data-add-to-cart');
    if (addValue && /^\d+$/.test(addValue)) return addValue;

    if (btn.dataset.variant && /^\d+$/.test(btn.dataset.variant)) return btn.dataset.variant;
    if (btn.dataset.variantId && /^\d+$/.test(btn.dataset.variantId)) return btn.dataset.variantId;
    if (btn.value && /^\d+$/.test(btn.value)) return btn.value;

    const form = btn.closest('form');
    const formId = form?.querySelector('[name="id"]')?.value;
    if (formId && /^\d+$/.test(formId)) return formId;

    const primary = document.querySelector('[data-add-to-cart][data-variant]');
    if (primary?.dataset.variant && /^\d+$/.test(primary.dataset.variant)) return primary.dataset.variant;

    const selected = new URLSearchParams(location.search).get('variant');
    if (selected && /^\d+$/.test(selected)) return selected;

    if (window.productVariants && Array.isArray(window.productVariants) && window.productVariants[0]) {
      const available = window.productVariants.find(v => v.available) || window.productVariants[0];
      return String(available.id || '');
    }

    return null;
  }

  function quantityFromButton(btn){
    const form = btn.closest('form');
    const candidates = [
      btn.dataset.quantity,
      btn.closest('.aesop-actions')?.querySelector('#AtlasQty')?.value,
      btn.closest('.atlas-sticky-actions')?.querySelector('#AtlasStickyQty')?.value,
      form?.querySelector('[name="quantity"]')?.value,
      document.querySelector('#AtlasQty')?.value
    ];
    const value = candidates.find(v => v !== undefined && v !== null && String(v).trim() !== '');
    return Math.max(1, parseInt(value || '1', 10) || 1);
  }

  function setButtonState(btn, state){
    if (!btn) return;
    if (!btn.dataset.flOriginalHtml) btn.dataset.flOriginalHtml = btn.innerHTML;

    // Keep plus / icon buttons visually clean. Do not replace their text with
    // "Adding…" or "Added". State is handled through classes only.
    btn.classList.toggle('is-loading', state === 'loading');
    btn.classList.toggle('is-added', state === 'added');
    btn.classList.toggle('is-error', state === 'error');
    btn.disabled = state === 'loading';

    if (state !== 'loading') {
      setTimeout(() => {
        btn.disabled = false;
        btn.classList.remove('is-loading','is-added','is-error');
        if (btn.dataset.flOriginalHtml) btn.innerHTML = btn.dataset.flOriginalHtml;
      }, state === 'added' ? 1050 : 1500);
    }
  }

  function toast(message){
    let el = document.querySelector('[data-toast], .toast, .fl-cart-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'fl-cart-toast';
      el.setAttribute('data-toast','');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('show','visible','is-visible');
    clearTimeout(el.__flTimer);
    el.__flTimer = setTimeout(() => el.classList.remove('show','visible','is-visible'), 1800);
  }

  async function refreshCartCount(){
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept':'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count || 0;
      });
      document.querySelectorAll('.fl-header-cart').forEach(icon => {
        icon.classList.remove('is-pulsing');
        void icon.offsetWidth;
        icon.classList.add('is-pulsing');
        setTimeout(() => icon.classList.remove('is-pulsing'), 760);
      });
    } catch(e) {}
  }

  async function addToCart(btn){
    const id = variantIdFromButton(btn);
    const quantity = quantityFromButton(btn);

    if (!id || !/^\d+$/.test(String(id))) {
      setButtonState(btn, 'error');
      toast('Could not find a valid variant.');
      return;
    }

    setButtonState(btn, 'loading');

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify({ id: Number(id), quantity })
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data.description || data.message || 'Could not add item');
      }

      setButtonState(btn, 'added');
      toast('Added to basket');
      await refreshCartCount();

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: data } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item: data } }));
      document.dispatchEvent(new CustomEvent('cart:changed', { detail: { item: data } }));
    } catch (err) {
      console.warn('[Flayvr cart add]', err);
      setButtonState(btn, 'error');
      toast(err.message || 'Could not add. Try again.');
    }
  }

  document.addEventListener('click', function(e){
    const btn = closestAddButton(e.target);
    if (!isProductAddButton(btn)) return;

    // Let cart drawer quantity controls pass through.
    if (btn.closest('[data-cart-line-key]')) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    addToCart(btn);
  }, true);

  document.addEventListener('submit', function(e){
    const form = e.target.closest && e.target.closest('[data-product-form], form[action*="/cart/add"]');
    if (!form || form.closest('.cart-drawer')) return;

    const btn = form.querySelector('button[type="submit"], button[name="add"], .product-form__submit') || form;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const id = form.querySelector('[name="id"]')?.value;
    const qty = form.querySelector('[name="quantity"]')?.value || 1;
    btn.dataset.variant = id || btn.dataset.variant || '';
    btn.dataset.quantity = qty;
    addToCart(btn);
  }, true);
})();



/* Alpha 93 discount checkout safety */
(function(){
  if(window.__flayvrDiscountCheckoutFix) return;
  window.__flayvrDiscountCheckoutFix = true;
  const KEY = 'flayvr:discount-code';

  function clean(v){ return String(v || '').trim(); }
  function saved(){ try { return localStorage.getItem(KEY) || ''; } catch(e) { return ''; } }
  function save(code){
    code = clean(code);
    try {
      if(code) localStorage.setItem(KEY, code);
      else localStorage.removeItem(KEY);
    } catch(e) {}
    return code;
  }
  function checkoutUrl(code){
    code = clean(code || saved());
    return code ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout' : '/checkout';
  }

  document.addEventListener('input', function(e){
    const input = e.target.closest && e.target.closest('[data-discount-input], [data-drawer-discount]');
    if(!input) return;
    const code = clean(input.value);
    if(code) save(code);
  }, true);

  document.addEventListener('click', function(e){
    const target = e.target.closest && e.target.closest('[data-cart-checkout], [data-drawer-checkout], a[href="/checkout"], a[href="/checkout/"], button[name="checkout"]');
    if(!target) return;

    const input = document.querySelector('[data-discount-input], [data-drawer-discount]');
    const code = clean(input?.value || saved());
    if(!code) return;

    save(code);
    e.preventDefault();
    e.stopPropagation();
    window.location.href = checkoutUrl(code);
  }, true);
})();




/* Alpha 94 clean add-to-cart state */
(function(){
  if(document.getElementById('flayvr-cart-add-state-style')) return;
  const style=document.createElement('style');
  style.id='flayvr-cart-add-state-style';
  style.textContent=`
    [data-add-to-cart].is-added,
    [data-mobile-add].is-added,
    .atlas-sticky-add.is-added,
    .product-form__submit.is-added,
    button[name="add"].is-added,
    .product-card-add.is-added,
    .flayvr-rec-add.is-added{
      background:#FE0435!important;
      color:#fff!important;
      border-color:#FE0435!important;
      box-shadow:0 16px 40px rgba(254,4,53,.24)!important;
    }
    [data-add-to-cart].is-loading,
    [data-mobile-add].is-loading,
    .atlas-sticky-add.is-loading,
    .product-form__submit.is-loading,
    button[name="add"].is-loading,
    .product-card-add.is-loading,
    .flayvr-rec-add.is-loading{
      opacity:.78!important;
      cursor:wait!important;
    }
    [data-add-to-cart].is-error,
    [data-mobile-add].is-error,
    .atlas-sticky-add.is-error,
    .product-form__submit.is-error,
    button[name="add"].is-error,
    .product-card-add.is-error,
    .flayvr-rec-add.is-error{
      background:#101014!important;
      color:#fff!important;
      border-color:#101014!important;
    }
  `;
  document.head.appendChild(style);
})();


/* Alpha 67 site-wide product-card footer and click repair — 26 Jul 2026 */
(function () {
  'use strict';

  if (window.__flayvrProductCardFooterRepair) return;
  window.__flayvrProductCardFooterRepair = true;

  const patterns = [
    ['.flrm21111__card', '.flrm21111__add', '.flrm21111__foot'],
    ['.flwk21111__card', '.flwk21111__add', '.flwk21111__foot'],
    ['.flrm21110__card', '.flrm21110__add', '.flrm21110__foot'],
    ['.flwk21110__card', '.flwk21110__add', '.flwk21110__foot'],
    ['.fl3m2114__card', '.fl3m2114__add', '.fl3m2114__foot'],
    ['.flwks2114__card', '.flwks2114__add', '.flwks2114__foot']
  ];

  function allWithin(root, selector) {
    const nodes = [];
    if (root && root.nodeType === 1 && root.matches(selector)) nodes.push(root);
    if (root && root.querySelectorAll) nodes.push(...root.querySelectorAll(selector));
    return nodes;
  }

  function normaliseButton(button) {
    if (!button) return;
    button.type = 'button';

    const legacyVariant = button.getAttribute('data-add');
    if (legacyVariant && !button.getAttribute('data-add-to-cart')) {
      button.setAttribute('data-add-to-cart', legacyVariant);
    }
  }

  function removeEmptyPlaceholder(footer, button) {
    [...footer.children].forEach((child) => {
      if (child === button) return;
      if (child.tagName === 'SPAN' && !child.className && !child.textContent.trim()) {
        child.remove();
      }
    });
  }

  function repair(root) {
    patterns.forEach(([cardSelector, buttonSelector, footerSelector]) => {
      allWithin(root, cardSelector).forEach((card) => {
        const button = card.querySelector(buttonSelector);
        const footer = card.querySelector(footerSelector);
        if (!button || !footer) return;

        normaliseButton(button);
        if (button.parentElement !== footer) footer.appendChild(button);
        removeEmptyPlaceholder(footer, button);
      });
    });

    allWithin(root, '.product-card, .flayvr-rec-card').forEach((card) => {
      const footer = card.querySelector('.product-card-footer, .flayvr-rec-footer');
      const button = card.querySelector('.product-card-add, .add-btn[data-add-to-cart], .add-btn[data-add]');
      if (!button) return;

      normaliseButton(button);
      if (footer && button.parentElement !== footer) footer.appendChild(button);
    });
  }

  function start(root) {
    repair(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(document), { once: true });
  } else {
    start(document);
  }

  document.addEventListener('shopify:section:load', (event) => start(event.target));

  let queued = false;
  const observer = new MutationObserver((records) => {
    if (queued || !records.some((record) => record.addedNodes && record.addedNodes.length)) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      start(document);
    });
  });

  if (document.documentElement) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
